import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const AddGenerateRoleActions = ({
  shift,
  setShiftUUIDForRole,
  setShowAddRole,
  handleGenerateTiers
}) => {
  return (
    <div className="flex justify-between items-center mt-3">
      {/* Add Role Button */}
      <Button
        className="flex font-inter font-medium text-sm text-fontGray border rounded-[8px] px-[10px] py-[6px]"
        onClick={() => {
          setShiftUUIDForRole(shift?.UUID);
          setShowAddRole(true);
        }}
        icon={<PlusOutlined className="align-baseline mt-three" />}
      >
        Add Role
      </Button>
    </div>
  );
};

export default AddGenerateRoleActions;
